export const translocoLang = 'translocoLang';
/**
 * Mounts transloco language pattern in front-end
 * When the response from back-end is 'pt' it must be changed to 'pt-BR'
 * @param {string} language
 * @return {string}
 */
export function getTranslocoLang(language: string): string {
  return language === 'pt' ? language + '-BR' : language;
}

/**
 * Mounts transloco language pattern to back-end
 * When input data is 'pt-BR' it must be changed to 'pt'
 * @param {string} language
 * @return {string}
 */
export function getTranslocoLangToBackEnd(language: string): string {
  return language === 'pt-BR' ? 'pt' : language;
}
